<template>
  <section class="banner__area pb-110 pt-110 grey-bg">

    <div class="container">
      <!-- <div class="events__shape">
        <img class="events-1-shape pt-200 " src="../../assets/img/events/events-shape.png" alt="">
      </div> -->

      <div class="row">
        <div class="col-xxl-4 offset-xxl-4">
          <div class="section__title-wrapper mb-60 text-center">
            <h2 class="section__title">
              A Jornada <span class="yellow-bg yellow-bg-big">Continua<img src="../../assets/img/shape/yellow-bg.png"
                  alt=""></span>
            </h2>
            <p>Sua trajetória é parte da nossa história! </p>
          </div>

        </div>
      </div>

      <div class="row">

        <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
          <div class="banner__item p-relative mb-40"
            :style="{ background: 'url(' + require('../../assets/img/banner/banner-bg-1.jpg') + ')', backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }">
            <div class="banner__content">
              <span>Participe</span>
              <h3 class="banner__title">
                <router-link to="/questionario">Questionário <br />
                  do Egresso</router-link>
              </h3>
              <router-link to="/questionario" class="e-btn e-btn-2">Acessar</router-link>
            </div>
            <div class="banner__thumb d-none d-sm-block d-md-none d-lg-block">
              <img src="../../assets/img/banner/banner-img-1.png" alt="" style=" width: 250px;" />
            </div>
            <div class="banner__thumb d-sm-block d-md-none d-lg-block">
              <img src="../../assets/img/banner/banner-img-1.png" alt="" style="opacity: 0.1; width: 250px;" />
            </div>
          </div>
        </div>
        <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
          <div class="banner__item p-relative mb-40"
            :style="{ background: 'url(' + require('../../assets/img/banner/banner-bg-2.jpg') + ')', backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }">
            <div class="banner__content">
              <span class="orange">Para você</span>
              <h3 class="banner__title">
                <router-link to="/oportunidades">Oportunidades <br />para o Egresso </router-link>
              </h3>
              <router-link to="/oportunidades" class="e-btn e-btn-2">Acessar</router-link>
            </div>
            <div class="
                banner__thumb
                d-none d-sm-block d-md-none d-lg-block
              ">
              <img src="../../assets/img/banner/banner-img-2.png" alt="" style=" width: 250px;" />
            </div>
            <div class="
                banner__thumb
               d-sm-block d-md-none d-lg-block
              ">
              <img src="../../assets/img/banner/banner-img-2.png" alt="" style="opacity: 0.1; width: 250px;" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
export default {
  name: "BannerArea",
};
</script>
